// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/cart_icon.sass
// module id = 199
// module chunks = 0